import { render, staticRenderFns } from "./NYTGamesCard.vue?vue&type=template&id=5967b504&scoped=true"
import script from "./NYTGamesCard.vue?vue&type=script&lang=js"
export * from "./NYTGamesCard.vue?vue&type=script&lang=js"
import style0 from "./NYTGamesCard.vue?vue&type=style&index=0&id=5967b504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5967b504",
  null
  
)

export default component.exports